// 添加数据时，输入数据的校验rule

// 正则校验的正则表达式，这里注意正则表达式中的‘\’要使用‘\\’转义
const patterns = {
  number: '^[0-9]+$',
  float: '^[0-9]+(\\.[0-9]{1,3})?$'
};

// 对应正则表达式的提示信息
const patternMsg = {
  number: '只能输入整数',
  float: '只能输入数字(至多三位小数)'
};

/**
 * 根据使用的正则返回对应的正则和信息对象
 * number：数字校验
 * float：数字且最多支持三位小数
 */
export function pattern(name, para = 'g') {
  return {
    pattern: new RegExp(patterns[name], para),
    message: patternMsg[name]
  };
};

/** 公共单价rule信息 */
export function priceRule() {
  return { max: 9999999.999, min: 0, type: 'number', message: '最大值不能超过 9999999.999 , 不能低于0!' };
};

/** 最小数字检查规则 */
export function minNumberRule(pMinNum = -9999999.999) {
  return { min: pMinNum, type: 'number', message: '最小值不能超过' + pMinNum + '!' };
};

/** 最大数字检查规则 */
export function maxNumberRule(pMaxNum = 9999999.999) {
  return { max: pMaxNum, type: 'number', message: '最大值不能超过' + pMaxNum + '!' };
};

/** 数字区间检查规则 */
export function maxMinNumberRule(pMaxNum = 9999999.999, pMinNum = 0) {
  return { max: pMaxNum, min: pMinNum, type: 'number', message: `最大值不能超过 ${pMaxNum} 位字符，最小值不能超过${pMinNum}!` };
};

/** 字符串最长检查规则 */
export function maxStringRule(pMax = 20) {
  return { max: pMax, type: 'string', message: `最大值不能超过${pMax}位字符!` };
};

/** 字符串长度区间检查规则 */
export function maxMinStringRule(pMax = 20, pMin = 3) {
  return { max: pMax, min: pMin, type: 'string', message: `最长不能超过${pMax}位字符，最短不能低于${pMin}位字符!` };
};

/** 单价小数检查规则 1-4位，最多四位小数 */
export function fractionalPriceRule(pMax) {
  const maxDigits = (!pMax || pMax > 4 || pMax < 1) ? 4 : pMax;
  const reg = new RegExp('^(([0]|[1-9][0-9]*)|(([0]\\.\\d{1,' + maxDigits + '}|[1-9][0-9]*\\.\\d{1,' + maxDigits + '})))$', 'g');
  return { pattern: reg, message: `请输入数字，最多${maxDigits}位小数！` };
};

/** 11位手机号检查规则 */
export function mobileRule() {
  return { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的11位手机号码！' };
}

/** 邮箱检查规则 */
export function emailRule() {
  return { type: 'email', message: '请输入正确的邮件地址！' };
}

/** 检查邮编 */
export function zipCodeRule() {
  return { pattern: /^[0-9]{6}$/, message: '请输入正确的邮编！' };
}
